import React from "react";

const EmployeeDocuments = () => {
  return <div>EmployeeDocuments</div>;
};

export default EmployeeDocuments;
